import gsap from 'gsap'
import { Transition } from '@unseenco/taxi'
import { startReveal } from '../components/reveal'
import { prefersReducedMotion } from '../utils/motion'

export default class DefaultTransition extends Transition {
	onLeave({ from, trigger, done }) {
		if (prefersReducedMotion()) {
			document.body.classList.remove('page-transition--in-progress')
			gsap.set('.page-transition', { autoAlpha: 0 })
			done()
			return
		}

		let leaveTimeline = gsap.timeline({
			onStart: () => {
				document.body.classList.add('page-transition--in-progress')
			},
			onComplete: () => {
				startReveal()
				done()
			},
		})
		leaveTimeline.to('.page-transition', {
			autoAlpha: 1,
			duration: 0.6,
			ease: 'sine.inOut',
		})
	}

	onEnter({ to, trigger, done }) {
		if (prefersReducedMotion()) {
			document.body.classList.remove('page-transition--in-progress')
			gsap.set('.page-transition', { autoAlpha: 0 })
			startReveal()
			done()
			return
		}

		let enterTimeline = gsap.timeline({
			onStart: () => {
				document.body.classList.add('page-transition--in-progress')
			},
			onComplete: () => {
				document.body.classList.remove('page-transition--in-progress')
				startReveal()
				done()
			},
		})
		enterTimeline.to('.page-transition', {
			autoAlpha: 0,
			duration: 0.6,
			ease: 'sine.inOut',
		})
	}
}
